// Ankiety (SMS po rozmowie). Sekcja jest ukryta w menu, więc mockup
// (design/voicesphere-dashboard.html) zna z niej tylko pojedyncze słowa: „Data i godzina",
// „Ocena", „Status", „Eksport CSV" (bez komentarza poniżej).
//
// VERIFY: cały plik poza wyżej wymienionymi, brak w mockupie. „Survey" = „ankieta".
//
// Klucze `conversationType.*`, `scoreOption.*`, `scoreType.*`, `category.*` to wartości
// z API / filtrów (`TextConversation`, `low`, `numeric`, `regular`), bo komponenty składają
// klucz z wartości: t(`scoreOption.${value}`). Wartość w logice zostaje angielska.
export default {
  header: {
    // VERIFY: brak w mockupie.
    refresh: 'Odśwież',
    // Licznik w nagłówku jest dwuwierszowy (CustomTableHeader): wiersz 1, <br>, wiersz 2.
    countLine1: 'Liczba',
    countLine2: 'ankiet',
    export: 'Eksport CSV',
    // VERIFY: oryginał mówi o „call history", choć eksport dotyczy ankiet; przetłumaczone wiernie.
    exportHint: 'Przygotuj i pobierz historię rozmów z wybranego okresu.',
    averageScore: {
      // VERIFY: CSAT zostaje jako skrót, bo tak nazywa się wskaźnik.
      title: 'Średnia ocena CSAT',
      hint: 'Średnia ocena z ankiet satysfakcji, obliczana na podstawie odpowiedzi na pytania o satysfakcję mieszkańców.',
      subtitle: 'Ogólna satysfakcja',
    },
  },
  // Nazwy pól: nagłówki kolumn tabeli i placeholdery filtrów.
  fields: {
    company: 'Firma',
    phone: 'Numer telefonu',
    dateTime: 'Data i godzina',
    smsContent: 'Treść SMS',
    type: 'Typ',
    conversationType: 'Typ rozmowy',
    score: 'Ocena',
    scoreType: 'Typ oceny',
    category: 'Kategoria',
    status: 'Status',
    conversation: 'Rozmowa',
  },
  conversationType: {
    TextConversation: 'SMS',
    // VERIFY: „AI Call" = „Rozmowa AI", „Agent Call" = rozmowa z człowiekiem, czyli urzędnikiem.
    AnalyticsCall: 'Rozmowa AI',
    AgentCall: 'Rozmowa z urzędnikiem',
  },
  scoreOption: {
    low: 'Ocena niska',
    medium: 'Ocena średnia',
    high: 'Ocena wysoka',
  },
  scoreType: {
    numeric: 'Liczbowa',
    text: 'Tekstowa',
  },
  category: {
    regular: 'Zwykła',
    // VERIFY: „Redirect" = ankieta przekierowująca (rodzaj ankiety), stąd „Przekierowanie".
    redirect: 'Przekierowanie',
  },
  status: {
    sent: 'Wysłana',
    notSent: 'Niewysłana',
    // VERIFY: „Received" = odpowiedź na ankietę dotarła; „Odebrana" myliłoby się z odebraną rozmową.
    received: 'Otrzymana',
  },
  export: {
    success: 'Plik został pobrany.',
    error: 'Nie udało się pobrać pliku',
  },
} as const;
